import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/auth/auth.service';
import { SistemaService } from 'src/app/services/sistema.service';

@Component({
  selector: 'app-portal-header',
  templateUrl: './portal-header.component.html',
  styleUrls: ['./portal-header.component.css']
})
export class PortalHeaderComponent implements OnInit {
  isLoggedIn = false;
  isAcessoInterno = false;
  profile: any = {};

  constructor(private authService: AuthService, private sistemaService: SistemaService) { }

  ngOnInit(): void {
    this.sistemaService.isAcessoInterno$.subscribe(isAcessoInterno => {
      this.isAcessoInterno = isAcessoInterno;
    });

    this.authService.profile$.subscribe(profile => {
      this.profile = profile;
    });

    this.authService.isLoggedIn$.subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
    });

  }

  logout() {
    this.authService.logout(window.location.origin + '/');
  }
}
